(function (angular) {
	angular.module('bizPartEngage').directive('bizMainMenu', bizMainMenuDirective);
	angular.module('bizPartEngage').directive('bizMainMenuBase', bizMainMenuBaseDirective);
	angular.module('bizPartEngage').directive('bizMenuJourney', bizMenuJourney);
	angular.module('bizPartEngage').directive('bizMenuJourneyCollection', bizMenuJourneyCollection);
	angular.module('bizPartEngage').directive('bizMenuJourneyStatus', bizMenuJourneyStatus);
	angular.module('bizPartEngage').service('bizMainMenuService', bizMainMenuService);
	angular.module('bizPartEngage').service('bizChatMenuActivity', bizChatMenuActivity);

	bizMainMenuDirective.$inject = ['bizCore'];
	bizMainMenuBaseDirective.$inject = ['bizCore'];
	bizMenuJourney.$inject = ['bizCore'];
	bizMenuJourneyCollection.$inject = ['bizCore'];
	bizMenuJourneyStatus.$inject = ['bizCore'];
	bizMainMenuService.$inject = ['$http'];
	bizChatMenuActivity.$inject = ['$rootScope', 'bizMainMenuService'];

	function bizMenuJourneyStatus(bizCoreProvider) {
		var directive = {
			restrict: 'E',
			scope: {},
			templateUrl: bizCoreProvider.getView(
				'core.directives.menu.journey',
				'FrontEnd/Core/Directives/Views/MenuJourneyStatus.html'
			),
			controller: bizMenuJourneyStatusController,
			controllerAs: 'vm',
			bindToController: true,
		};

		bizMenuJourneyStatusController.$inject = ['$rootScope', 'bizJourneyService'];

		function bizMenuJourneyStatusController($rootScope, bizJourneyService) {
			var vm = this;

			vm.Init = Init;

			vm.SetCurrentJourney = SetCurrentJourney;
			vm.GoToNextJourneyObject = GoToNextJourneyObject;
			vm.SetNextJourneyObject = SetNextJourneyObject;
			vm.CloseJourneyPanel = CloseJourneyPanel;

			vm.JourneyPanelOpen = false;

			function CloseJourneyPanel() {
				vm.JourneyPanelOpen = false;
			}

			function GoToNextJourneyObject(event) {
				event.stopPropagation();

				bizJourneyService.GoToEngageItem(vm.NextJourneyObject);
			}

			function SetCurrentJourney() {
				$rootScope.JourneysInitialized.then(() => {
					if ($rootScope.Journeys) {
						for (var i = 0; i < $rootScope.Journeys.length; i++) {
							if ($rootScope.Journeys[i].IsCurrentJourney) {
								vm.CurrentJourney = $rootScope.Journeys[i];
							}
						}
					}

					vm.SetNextJourneyObject();
				});
			}

			function SetNextJourneyObject() {
				if (vm.CurrentJourney) {
					var nextObject;
					for (var i = 0; i < vm.CurrentJourney.EngageObjects.length; i++) {
						if (!nextObject && vm.CurrentJourney.EngageObjects[i].Status !== 3) {
							nextObject = vm.CurrentJourney.EngageObjects[i];
						}
					}
					vm.NextJourneyObject = nextObject;
				}
			}

			function Init() {
				vm.SetCurrentJourney();

				$rootScope.$on('CURRENT_JOURNEY_CHANGED', (event, args) => {
					vm.SetCurrentJourney();
				});

				$rootScope.$on('JOURNEY_OBJECT_UPDATED', (event, args) => {
					vm.SetNextJourneyObject();
				});
			}

			this.$onInit = vm.Init;
		}

		return directive;
	}

	function bizMenuJourney(bizCoreProvider) {
		var directive = {
			restrict: 'E',
			scope: {
				journey: '=?',
				fromCollection: '@?',
			},
			templateUrl: bizCoreProvider.getView(
				'core.directives.menu.journey',
				'FrontEnd/Core/Directives/Views/MenuJourney.html'
			),
			controller: bizMenuJourneyController,
			controllerAs: 'vm',
			bindToController: true,
		};

		bizMenuJourneyController.$inject = ['$rootScope'];

		function bizMenuJourneyController($rootScope) {
			var vm = this;
			vm.Init = Init;
			vm.Round = Round;

			function Init() {}

			function Round(p) {
				return Math.round(p);
			}

			this.$onInit = vm.Init;
		}

		return directive;
	}

	function bizMenuJourneyCollection(bizCoreProvider) {
		var directive = {
			restrict: 'E',
			scope: {
				closeFunc: '&',
			},
			templateUrl: bizCoreProvider.getView(
				'core.directives.menu.journey',
				'FrontEnd/Core/Directives/Views/MenuJourneyCollection.html'
			),
			controller: bizMenuJourneyCollectionController,
			controllerAs: 'vm',
			bindToController: true,
		};

		bizMenuJourneyCollectionController.$inject = ['$rootScope', 'bizJourneyService', '$state'];

		function bizMenuJourneyCollectionController($rootScope, bizJourneyService, $state) {
			var vm = this;
			vm.Init = Init;
			vm.GoToJourneyPage = GoToJourneyPage;
			vm.SetCurrentJourney = SetCurrentJourney;

			function SetCurrentJourney(id) {
				if ($rootScope.Journeys && $rootScope.Journeys.length) {
					$rootScope.SetCurrentJourney(id, true);
					vm.closeFunc();
				}
			}

			function GoToJourneyPage() {
				vm.closeFunc();
				$state.go('base.modules.journey');
			}

			function Init() {}

			this.$onInit = vm.Init;
		}

		return directive;
	}

	function bizMainMenuDirective(bizCoreProvider) {
		var directive = {
			restrict: 'E',
			scope: {
				menuItems: '=?',
				systemName: '@?',
				IsAppMenuVisible: '=?',
				mobilemode: '=?',
			},
			templateUrl: function (element, attr) {
				if (attr.templateurl) {
					return siteRootPath + attr.templateurl + "?v=" + bizPartVersion;
				}
				else {
					return bizCoreProvider.getView('core.directives.main.menu', 'FrontEnd/Core/Directives/Views/MainMenu.html');
				}
			},
			controller: bizMainMenuController,
			controllerAs: 'vm',
			bindToController: true,
		};

		bizMainMenuController.$inject = [
			'$state',
			'$stateParams',
			'scrollService',
			'$rootScope',
			'bizMainMenuService',
			'core.users.service',
			'bizCoreService',
			'$window',
			'$filter',
			'$timeout',
			'$scope',
			'$parse',
			'bizChatMenuActivity',
		];

		function bizMainMenuController(
			$state,
			$stateParams,
			scrollService,
			$rootScope,
			bizMainMenuService,
			userService,
			bizCoreService,
			$window,
			$filter,
			$timeout,
			$scope,
			$parse,
			bizChatMenuActivity
		) {
			var vm = this;
			vm.showMenu = true; //required to be able to update the menu if needed because it is onetime bound
			vm.GetItemLink = GetItemLink;
			vm.Navigate = Navigate;
			vm.IsActiveItem = IsActiveItem;
			vm.IsAnchorLink = IsAnchorLink;
			vm.HandleMenuClick = HandleMenuClick;
			vm.IsExpandedByDefault = IsExpandedByDefault;
			vm.IsClickOutsideActive = IsClickOutsideActive;
			vm.CurrentLocation = CurrentLocation;
			vm.Logout = Logout;
			vm.Login = Login;
			vm.ChangeCulture = ChangeCulture;
			vm.Init = Init;

			vm.ShowInstallPWA = ShowInstallPWA;
			vm.InstallPWA = InstallPWA;
			vm.HasInstalledPwa = false;
			vm.ShowJourneyWidget = false;

			vm.lastScrollTop = 0;
			vm.scrollTop = 0;
			vm.scrollDirection = '';
			vm.hasSentCloseEvent = false;

			vm.AppMenuEntries = [];
			$rootScope.IsAppMenuVisible = false;

			var objectTypeSettings = {
				100: {
					Name: 'CMSPage',
					State: 'base.modules.cms',
					Identifier: 'id',
				},
			};

			function isVisibleInAppMenu(node) {
				if (!node || node.IsDeleted || !node.IsActive) return false;
				if (node.IsActiveInAppMenu) return true;
				return (node.Children || []).some(isVisibleInAppMenu);
			}

			function Logout() {
				userService.Logout();
			}

			function Login() {
				console.log('login');
				if (vm.OpenIdProviderId) {
					$window.location.href = $filter('siteroot')('OpenIdLogin/' + vm.OpenIdProviderId);
				} else {
					$window.location.href = $filter('siteroot')('login');
				}
			}

			function ChangeCulture(culture) {
				if (culture.QueryString) {
					$window.location.href = $filter('siteroot')('/' + culture.QueryString);
				}
			}

			function HandleAppMenuItems() {
				vm.AppMenuEntries = [];
				var appMenuResponse = $rootScope.AppMenuResponse;
				var sourceItems = appMenuResponse ? appMenuResponse.items : ($rootScope.MenuItems || []);
				var useLegacyFlags = !appMenuResponse || appMenuResponse.usedFallback;
				(sourceItems || []).forEach(parent => {
					if (!useLegacyFlags) {
						vm.AppMenuEntries.push({ type: "item", item: parent, cssClass: parent.CssClass });
						return;
					}
					if (!isVisibleInAppMenu(parent)) return;

					const visibleChildren = (parent.Children || []).filter(c =>
						c && !c.IsDeleted && c.IsActive && c.IsActiveInAppMenu
					);

					if (parent.IsActiveInAppMenu) {
						vm.AppMenuEntries.push({ type: "item", item: parent, cssClass: parent.CssClassAppMenu });
					} else {
						visibleChildren.forEach(c => vm.AppMenuEntries.push({
							type: "child", item: c, parent, cssClass: c.CssClassAppMenu
						}));
					}
				});
        
				$rootScope.IsAppMenuVisible = vm.AppMenuEntries.length > 0;
			}

			function HandleMenuClick(item, parentItem) {
				if (!bizChatMenuActivity.HandleMenuClick(item)) item.HasActivity = false;
				// Show/Hide sub-menus
				if (item.Children.length > 0) {
					if (item.Expanded === true) {
						item.Expanded = false;
						return;
					}

					for (var i = 0; i < $rootScope.MenuItems.length; i++) {
						$rootScope.MenuItems[i].Expanded = false;
					}

					item.Expanded = !item.Expanded;
					return;
				}

				if (parentItem && !IsExpandedByDefault(parentItem)) parentItem.Expanded = false;

				$rootScope.ExpandMainMenu = false;

				// External/http links
				if (item.Link.indexOf(window.location.hostname) > -1) {
					window.location.href = item.Link;
					return;
				} else if (item.Link.startsWith('http')) {
					window.open(item.Link, '_blank');
					return;
				}

				// Anchor links
				if (IsAnchorLink(item)) {
					if (item.Link.indexOf('#') == 0) {
						scrollService.ScrollTo($(item.Link), 0);
					} else {
						location.href = item.Link;
					}
				}

				return false;
			}

			function IsExpandedByDefault(item) {
				return item.IsExpandedByDefault === true && ($rootScope.mobile === true || vm.mobilemode === true);
			}

			function IsClickOutsideActive(item) {
				if (item.Expanded !== true) return false;
				if (IsExpandedByDefault(item)) return false;
				if ($rootScope.mobile === true || vm.mobilemode === true) return $rootScope.ExpandMainMenu === true;
				return true;
			}

			function CurrentLocation() {
				return location.href.replace(location.hash, '');
			}

			function IsActiveItem(item) {
				if (!item) return;

				var state = $state.current;
				if (IsParameterizedStateLinkActive(item.Link, state, $stateParams, $parse)) return true;

				if (typeof item === 'string') {
					if (item == state.name || (state.data && state.data.parentState === item)) {
						return true;
					} else {
						return false;
					}
				} else if (
					item.Link == state.name ||
					(state.data !== undefined && item.Link == state.data.parentState) ||
					item.ControllerScope == state.name ||
					(state.data !== undefined && item.ControllerScope === state.data.parentState)
                    || $stateParams.filter !== undefined && item.Link == state.name + '({filter:\'' + $stateParams.filter + '\'})'
				) {
					return true;
				} else if (item.ObjectType == 100 && $stateParams !== undefined && $stateParams.id == item.ObjectIdentifier) {
					return true;
				} else {
					return false;
				}
			}

			function IsAnchorLink(item) {
				if (item.Link.indexOf('#') > -1) {
					return true;
				}

				return false;
			}

			function GetItemLink(item) {
				if (!item.ObjectType) return item.Link;

				var setting = objectTypeSettings[item.ObjectType];
				if (setting) {
					var link = String.format('{0}({{1}:"{2}"})', setting.State, setting.Identifier, item.ObjectIdentifier);
					return link;
				}

				return item.Link;
			}

			function Navigate(url) {
				$state.go(url);
			}

			function ShowInstallPWA() {
				if (
					IsPortalSettingTrue('IsPWAEnabled') &&
					$rootScope.mobile &&
					pwaDeferredPrompt !== undefined &&
					!vm.HasInstalledPwa
				) {
					return true;
				} else {
					return false;
				}
			}

			function InstallPWA(e) {
				vm.HasInstalledPwa = true;
				installPWA(e);
			}

			function onScroll() {
				// only for desktop

				vm.scrollTop = $window.pageYOffset || document.documentElement.scrollTop;
				vm.scrollDirection = vm.lastScrollTop < vm.scrollTop ? 'down' : 'up';

				if (vm.scrollDirection === 'down' && vm.scrollTop > 5 && vm.hasSentCloseEvent === false) {
					// iOS fix 5px
					$rootScope.ExpandMainMenu = false;
					vm.hasSentCloseEvent = true;
					$rootScope.$digest();
				}

				if (vm.scrollDirection === 'up') {
					vm.hasSentCloseEvent = false;
				}

				vm.lastScrollTop = vm.scrollTop;
			}

			function Init() {
				bizChatMenuActivity.Attach($scope, function () { return vm.menuItems; });
				vm.ShowAppMenu = !vm.systemName || vm.systemName.toUpperCase() === 'MAINMENU';
				if (vm.systemName) {
					bizMainMenuService.GetMenuBySystemName(vm.systemName).then(function (response) {
						vm.menuItems = response.data.items;
					});
				}
				if (IsPortalSettingTrue('IsJourneyEnabled')) {
					vm.ShowJourneyWidget = IsPortalSettingTrue('IsJourneyMenuWidgetEnabled');
				}
				vm.ShowTipSomeone = IsPortalSettingTrue('IsShowTipSomeoneEnabled');
				vm.OpenIdProviderId = portalSettings['loginopenidp'];

				if ($rootScope.mobile === false) $window.addEventListener('scroll', onScroll);

				if (IsPortalSettingTrue('IsAppMenuEnabled')) {
					$rootScope.$watch('MenuItems', function (newVal, oldVal) {
						if (newVal !== oldVal && ($rootScope.mobile || vm.AppMenuEntries.length === 0)) {
							HandleAppMenuItems();
						}
					}, true);
					$rootScope.$watch('AppMenuResponse', function (newVal) {
						if (newVal) {
							HandleAppMenuItems();
						}
					}, true);
				}
			}

			this.$onInit = vm.Init;

			$rootScope.$on('MAIN_MENU_UPDATED', function (event, args) {
				//menu is onetime bound, so we need to hide the entire thing and then show it again
				vm.showMenu = false;
				$timeout(() => {
					vm.showMenu = true;
				});
			});
		}

		return directive;
	}

	function bizMainMenuBaseDirective(bizCoreProvider) {
		var directive = {
			restrict: 'E',
			scope: {
				menuItems: '=?',
				systemName: '@?',
			},
			templateUrl: function (element, attr) {
				if (attr.templateurl) {
					return siteRootPath + attr.templateurl + "?v=" + bizPartVersion;
				}
				else {
					return bizCoreProvider.getView('core.directives.main.menu', 'FrontEnd/Core/Directives/Views/MainMenuBase.html');
				}
			},
			controller: bizMainMenuBaseController,
			controllerAs: 'vm',
			bindToController: true,
		};

		bizMainMenuBaseController.$inject = [
			'$state',
			'$stateParams',
			'scrollService',
			'$rootScope',
			'bizMainMenuService',
			'$parse',
			'bizChatMenuActivity',
			'$scope',
		];

		function bizMainMenuBaseController(
			$state,
			$stateParams,
			scrollService,
			$rootScope,
			bizMainMenuService,
			$parse,
			bizChatMenuActivity,
			$scope
		) {
			var vm = this;
			vm.showMenu = true; //required to be able to update the menu if needed because it is onetime bound
			vm.GetItemLink = GetItemLink;
			vm.Navigate = Navigate;
			vm.IsActiveItem = IsActiveItem;
			vm.IsAnchorLink = IsAnchorLink;
			vm.HandleMenuClick = HandleMenuClick;
			vm.Init = Init;


			var objectTypeSettings = {
				100: {
					Name: 'CMSPage',
					State: 'base.modules.cms',
					Identifier: 'id',
				},
			};

			function HandleMenuClick(item, parentItem) {
				if (!item) return false;

				if (!bizChatMenuActivity.HandleMenuClick(item)) item.HasActivity = false;
				if ((item.Children || []).length > 0) {
					if (item.Expanded === true) {
						item.Expanded = false;
						return false;
					}

					(vm.menuItems || []).forEach(function (menuItem) {
						menuItem.Expanded = false;
					});
					item.Expanded = true;
					return false;
				}

				if (parentItem) parentItem.Expanded = false;
				$rootScope.ExpandMainMenu = false;

				var link = item.Link || '';
				if (link.indexOf(window.location.hostname) > -1) {
					window.location.href = link;
					return false;
				} else if (link.startsWith('http')) {
					window.open(link, '_blank');
					return false;
				}

				if (IsAnchorLink(item)) {
					if (link.indexOf('#') == 0) {
						scrollService.ScrollTo($(link), 0);
					} else {
						location.href = link;
					}
				}

				return false;
			}

			function IsActiveItem(item) {
				if (!item) return false;

				var state = $state.current;
				if (IsParameterizedStateLinkActive(item.Link, state, $stateParams, $parse)) return true;
				if (typeof item === 'string') {
					return item == state.name || (state.data && state.data.parentState === item);
				}

				if (
					item.Link == state.name ||
					(state.data !== undefined && item.Link == state.data.parentState) ||
					item.ControllerScope == state.name ||
					(state.data !== undefined && item.ControllerScope === state.data.parentState) ||
					($stateParams.filter !== undefined && item.Link == state.name + '({filter:\'' + $stateParams.filter + '\'})')
				) {
					return true;
				}

				return item.ObjectType == 100 && $stateParams.id == item.ObjectIdentifier;
			}

			function IsAnchorLink(item) {
				if ((item.Link || '').indexOf('#') > -1) {
					return true;
				}

				return false;
			}

			function GetItemLink(item) {
				if (!item.ObjectType) return item.Link;

				var setting = objectTypeSettings[item.ObjectType];
				if (setting) {
					var link = String.format('{0}({{1}:"{2}"})', setting.State, setting.Identifier, item.ObjectIdentifier);
					return link;
				}

				return item.Link;
			}

			function Navigate(url) {
				$state.go(url);
			}

			function Init() {
				bizChatMenuActivity.Attach($scope, function () { return vm.menuItems; });
				if (!vm.systemName) return;

				vm.showMenu = false;
				bizMainMenuService.GetMenuBySystemName(vm.systemName).then(function (response) {
					vm.menuItems = response.data.items;
					vm.showMenu = true;
				});
			}

			this.$onInit = vm.Init;

			//$rootScope.$on('MAIN_MENU_UPDATED', function (event, args) {
			//	//menu is onetime bound, so we need to hide the entire thing and then show it again
			//	vm.showMenu = false;
			//	$timeout(() => {
			//		vm.showMenu = true;
			//	});
			//});
		}

		return directive;
	}

	function IsParameterizedStateLinkActive(link, state, stateParams, $parse) {
		if (!link || !state) return false;

		var match = /^\s*([^\s(]+)\s*\((.*)\)\s*$/.exec(link);
		if (!match) return false;

		var stateName = match[1];
		var parentStateName = state.data && state.data.parentState;
		if (stateName !== state.name && stateName !== parentStateName) return false;

		try {
			var expectedParams = $parse(match[2])() || {};
			return Object.keys(expectedParams).every(function (key) {
				return String(stateParams[key]) === String(expectedParams[key]);
			});
		} catch (error) {
			return false;
		}
	}

	function bizChatMenuActivity($rootScope, bizMainMenuService) {
		var roomActivity = {};
		var currentRoomId = null;
		var revision = 0;
		var roomRevisions = {};
		var clearedRevision = 0;
		var latestRequestId = 0;

		this.Attach = function ($scope, getMenuItems) {
			initialize();
			$scope.$watchGroup([
				getMenuItems,
				function () { return $rootScope.MenuItems; },
				function () { return $rootScope.AppMenuResponse && $rootScope.AppMenuResponse.items; },
				shouldShowChatMenuActivity,
			], function () {
				syncItems(getMenuItems());
				syncItems($rootScope.MenuItems);
				syncItems($rootScope.AppMenuResponse && $rootScope.AppMenuResponse.items);
			});
		};

		this.HandleMenuClick = function (item) {
			if (!isChatMenuItem(item)) return false;
			if (shouldClearChatActivityOnMenuClick()) clearAllChatRoomActivity();
			item.HasActivity = shouldShowChatMenuActivity();
			return true;
		};

		function syncItems(items) {
			(items || []).forEach(function (item) {
				if (isChatMenuItem(item)) item.HasActivity = shouldShowChatMenuActivity();
				syncItems(item.Children);
			});
		}

		var CHAT_MENU_STATE = 'base.modules.chat';
		var CHAT_STATE_ACTIVITY_EXCLUSIONS = ['base.modules.chatdirectmessage', 'base.modules.event'];
		var CHAT_BROADCAST_TYPE_CHAT_EVENT = 0;
		var CHAT_BROADCAST_TYPE_ROOM_EVENT = 3;
		var CHAT_EVENT_TYPE_MESSAGE_TO_ROOM = 0;
		var CHAT_ACTIVITY_EVENT_NAME = 'chatActivity';
		var initialized = false;

		function initialize() {
			if (initialized || !IsPortalSettingTrue('IsChatEnabled')) return;
			initialized = true;
			$rootScope.$on('HUB_CHAT', onHubMsg);
			$rootScope.$on('HUB_ConnectionStateChange', onHubConnectionStateChange);
			$rootScope.$on(CHAT_ACTIVITY_EVENT_NAME, onChatActivityEvent);
			$rootScope.Initialized.then(loadInitialChatActivity);
		}

		function onHubMsg(event, args) {
			if (args.HubKey === 'CHAT' && args.Content) {
				var chatRoomId = getChatActivityRoomIdFromHubMessage(args);
				if (chatRoomId) {
					setChatRoomActivity(chatRoomId);
				}
			}
		}

		function onHubConnectionStateChange(event, connectionState) {
			if (connectionState === 'CONNECTED') {
				loadInitialChatActivity();
			}
		}

		function onChatActivityEvent(event, detail) {
			detail = detail || {};

			if (detail.action === 'set-room-activity') {
				setChatRoomActivity(detail.chatRoomId);
			} else if (detail.action === 'clear-room-activity') {
				clearChatRoomActivity(detail.chatRoomId);
			} else if (detail.action === 'current-room-changed') {
				currentRoomId = parseInt(detail.chatRoomId, 10) || null;
				$rootScope.$evalAsync();
			}
		}

		function getChatActivityRoomIdFromHubMessage(args) {
			var chatMessage = parseChatBroadcastContent(args.Content);
			if (!chatMessage || !chatMessage.Data) {
				return null;
			}

			if (chatMessage.Data.EventType !== CHAT_EVENT_TYPE_MESSAGE_TO_ROOM) {
				return null;
			}

			if (chatMessage.BroadcastType === CHAT_BROADCAST_TYPE_ROOM_EVENT ||
				chatMessage.BroadcastType === CHAT_BROADCAST_TYPE_CHAT_EVENT) {
				return chatMessage.Data.ChatRoomId || chatMessage.RoomId || null;
			}

			return null;
		}

		function parseChatBroadcastContent(content) {
			try {
				return typeof content === 'string' ? JSON.parse(content) : content;
			} catch (e) {
				console.error('Could not parse chat activity message', e);
				return null;
			}
		}

		function loadInitialChatActivity() {
			if (!IsPortalSettingTrue('IsChatEnabled') || !$rootScope.LoggedInUser || $rootScope.LoggedInUser.Id <= 0) {
				return;
			}

			var requestId = ++latestRequestId;
			var requestRevision = revision;
			bizMainMenuService.GetNotDeliveredMessagesCountForUser()
				.then(function (response) {
					if (requestId !== latestRequestId || clearedRevision > requestRevision) return;
					var nextActivity = {};
					(response.data || []).forEach(function (room) {
						if (room.ChatRoomId && room.NewMessagesCount > 0) nextActivity[room.ChatRoomId] = true;
					});
					// Preserve messages and read acknowledgements received while this request was in flight.
					Object.keys(roomRevisions).forEach(function (roomId) {
						if (roomRevisions[roomId] <= requestRevision) return;
						if (roomActivity[roomId]) nextActivity[roomId] = true;
						else delete nextActivity[roomId];
					});
					roomActivity = nextActivity;
					$rootScope.$evalAsync();
				})
				.catch(function () {});
		}

		function setChatRoomActivity(chatRoomId) {
			chatRoomId = parseInt(chatRoomId, 10);
			if (!chatRoomId) return;

			if (currentRoomId && chatRoomId === currentRoomId) {
				clearChatRoomActivity(chatRoomId);
				return;
			}

			roomRevisions[chatRoomId] = ++revision;
			roomActivity[chatRoomId] = true;
			$rootScope.$evalAsync();
		}

		function clearChatRoomActivity(chatRoomId) {
			chatRoomId = parseInt(chatRoomId, 10);
			if (!chatRoomId) return;

			roomRevisions[chatRoomId] = ++revision;
			delete roomActivity[chatRoomId];
			$rootScope.$evalAsync();
		}

		function clearAllChatRoomActivity() {
			clearedRevision = ++revision;
			roomActivity = {};
			$rootScope.$evalAsync();
		}

		function shouldShowChatMenuActivity() {
			var activeRoomIds = Object.keys(roomActivity);
			if (activeRoomIds.length === 0) return false;

			if (!isCurrentStateChatRelated()) return true;
			if ($rootScope.mobile !== true) return false;
			if (!currentRoomId) return true;

			return activeRoomIds.some(function (roomId) {
				return parseInt(roomId, 10) !== currentRoomId;
			});
		}

		function isCurrentStateChatRelated() {
			if (!$rootScope.CurrentState) return false;

			return (
				$rootScope.CurrentState.name === CHAT_MENU_STATE ||
				CHAT_STATE_ACTIVITY_EXCLUSIONS.indexOf($rootScope.CurrentState.name) > -1
			);
		}

		function isChatMenuItem(item) {
			return item && item.Link === CHAT_MENU_STATE;
		}

		function shouldClearChatActivityOnMenuClick() {
			return !($rootScope.mobile === true && isCurrentStateChatRelated() && currentRoomId);
		}

	}

	function bizMainMenuService($http) {
		var menuServicePath = siteRootPath + 'api/menu/';
		var chatServicePath = siteRootPath + 'api/chat/';

		this.GetMenuBySystemName = function (systemName) {
			return $http.get(menuServicePath + 'GetMenuBySystemName', { params: { systemName: systemName } })
				.then(function (response) {
					response.data.items = (response.data.items || []).map(mapMenuItem);
					return response;
				});
		};

		function mapMenuItem(item) {
			return {
				Id: item.id, Name: item.name, Link: item.link, Order: item.order, ParentId: item.parentId,
				CssClass: item.cssClass, CssClassAppMenu: item.cssClassAppMenu, ObjectId: item.objectId,
				ObjectType: item.objectType, ObjectIdentifier: item.objectIdentifier, ControllerScope: item.controllerScope,
				IsActive: item.isActive, IsDeleted: item.isDeleted, IsActiveInAppMenu: item.isActiveInAppMenu,
				IsExpandedByDefault: item.isExpandedByDefault,
				IsAnonymousOnly: item.isAnonymousOnly, Children: (item.children || []).map(mapMenuItem)
			};
		}

		this.GetNotDeliveredMessagesCountForUser = function () {
			return $http.get(chatServicePath + 'GetNotDeliveredMessagesCountForUser');
		};
	}
})(window.angular);
